import AuthenticatedRoute from 'eflex/util/authenticated-route';
import QueryParams from 'eflex/constants/bi-query-params';
export default class BiQualityIndexRoute extends AuthenticatedRoute {
  queryParams = QueryParams;
}
